<script src="../../../../../../../../../Downloads/angular-ml--medium--clone/07 ‚áŻ®¬®Ł âĄ«ě­ëĄ ¬®¤ă«¨/mediumclone_angular-48-rendering-user-profile/src/app/article/services/article.service.ts"></script>
<div class="article-page">
  <div class="banner">
    <div class="container" *ngIf="article">
      <h1>{{ article.title }}</h1>
      <div class="article-meta">
        <a [routerLink]="['/profiles', article.author.username]">
          <img [src]="article.author.image" *ngIf="article.author.image" alt="Avatar" />
        </a>

        <div class="info">
          <a [routerLink]="['/profiles', article.author.username]">
            {{ article.author.username }}
          </a>
          <span class="date">{{ article.createdAt }}</span>
        </div>
        <span class="" *ngIf="isAuthor$ | async">
          <a [routerLink]="['/articles', article.slug, 'edit']" class="btn btn-outline-secondary btn-sm">
            <i class="ion-edit"></i>
            Edit article
          </a>
          <button class="bnt btn-outline-danger btn-sm" (click)="deleteArticle()">Delete Article</button>
        </span>
      </div>
    </div>
  </div>
  <div class="container page">
    <app-loading *ngIf="isLoading$ | async"></app-loading>
    <app-error-message *ngIf="error$ | async"></app-error-message>

    <div class="row article-content" *ngIf="article">
      <div class="col-xs-12">
        <div class="">
          <p>{{ article.body }}</p>
        </div>
        <app-tag-list [tags]="article.tagList"></app-tag-list>
      </div>
    </div>
  </div>
</div>
